import { FC } from "react";
import styled from "styled-components";
import { Icon } from "../../Icon";
import { expandIconAnimation } from "../../expandIconAnimation";
import { SelectComponentProps } from "./types";

type StyledDropdownIndicatorProps = {
  expanded: boolean;
};

const StyledDropdownIndicator = styled.div<StyledDropdownIndicatorProps>`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 100%;
  padding: 0 8px;
  &.animate-icon {
    ${expandIconAnimation}
  }
`;

type DropdownIndicatorProps = SelectComponentProps["DropdownIndicator"];

export const DropdownIndicator: FC<DropdownIndicatorProps> = ({
  isFocused,
  selectProps: {
    isDisabled,
    menuIsOpen,
    dropdownIndicatorIconName,
    isDropdownIndicatorIconAnimated = true,
  },
}) => (
  <StyledDropdownIndicator
    data-testid="DropdownIndicator"
    expanded={menuIsOpen ?? false}
    className={isDropdownIndicatorIconAnimated ? "animate-icon" : ""}
  >
    {isFocused ? (
      <Icon
        iconName={dropdownIndicatorIconName ?? "chevron-down"}
        iconSize="small"
        variant="ACTIVE"
        plain
      />
    ) : (
      <Icon
        iconName={dropdownIndicatorIconName ?? "chevron-down"}
        iconSize="small"
        variant={isDisabled ? "DISABLED" : "DEFAULT"}
        plain
      />
    )}
  </StyledDropdownIndicator>
);
